import { render, staticRenderFns } from "./MessageContentCard.vue?vue&type=template&id=3ce48cce&scoped=true"
import script from "./MessageContentCard.vue?vue&type=script&lang=js"
export * from "./MessageContentCard.vue?vue&type=script&lang=js"
import style0 from "./MessageContentCard.vue?vue&type=style&index=0&id=3ce48cce&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ce48cce",
  null
  
)

export default component.exports